import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import EditDealershipSettings from '../../../inputs/EditDealershipSettings';
import EditTabStyle from './EditTabStyle';
import EditTabProperties from '../../../inputs/EditTabProperties';
import AddListItemButton from '../../../inputs/AddListItemButton';
import { addNewVehicleColumnID, addNewVehicleColumn } from '../../../actions/apiDepartmentUpdates';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';

const EditVehicleHistory = (props) => {
    const [errors, setErrors] = useState({ addDepartmentPropertyError: false });
    const [optionName, setOptionName] = useState('');
    const dispatch = useDispatch();
    const { tab } = props;

    const onChange = (e) => {
        setOptionName(e.target.value);
    };

    const onClick = () => {
        const errorType = 'addTabProperty';
        const data = {
            key: 'use_work_flow',
            value: 'used',
            tab_id: tab.id,
            name: 'use_work_flow',
        };

        dispatch(addTabProperty(data, errorType));
    };

    const onDelete = (e) => {
        const errorType = 'Delete Tab Property';
        const { id } = e.target.dataset;
        dispatch(deleteTabProperty(id, errorType));
    };

    return (
        <div className="col-md-12">
            <h3 className="text-center">Checklist</h3>

            <div className="card space-top-1">
                <div className="card-text">
                    <h3>Checklist Settings</h3>
                    <div className="col-md-12">
                        <small>
                            <i className={'fa fa-info-circle text-info'} />
                            {' '}
                            Choose from an existing vehicle column or create a new column and then add it to the list.
                        </small>
                        <AddListItemButton
                            field={'option_name'}
                            value={optionName}
                            label={'test'}
                            error={errors.addDepartmentPropertyError}
                            type={'text'}
                            onChange={onChange}
                            onClick={onClick}
                        />
                    </div>

                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>order</th>
                                <th>name</th>
                                <th>key</th>
                                <th>value</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tab.tab_properties.map((tab_property) => {
                                if (tab_property.name === 'use_work_flow') {
                                    return (
                                        <tr key={`tab_property_${tab_property.id}`}>
                                            <td>{tab_property.order}</td>
                                            <td>{tab_property.name}</td>
                                            <td>{tab_property.key}</td>
                                            <td>{tab_property.value}</td>
                                            <td>
                                                <button className={'btn btn-danger btn-sm'} onClick={onDelete} data-id={tab_property.id}>X</button>
                                            </td>
                                        </tr>
                                    );
                                }
                                return null; // Return null for other properties
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EditVehicleHistory;
